import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { cloneDeep, set } from 'lodash';
import { useMutationWithCacheUpdate, useTableDataState } from '../../state/table-data.state';

import unlockIcon from '@ingka/ssr-icon/paths/lock-open';
import { useCallback } from 'react';
import { useSubItemsFromSelections } from '../../state/selection.state';

export const UnlockButton = () => {
   const mutate = useMutationWithCacheUpdate('Material(s) successfully unlocked');
   const selectedSubItems = useSubItemsFromSelections();

   const onClick = () => {
      const updated = selectedSubItems.map((subItem) => set(cloneDeep(subItem), 'locked', false));
      const updatedIds = new Set(updated.map((u) => `${u.parentId}:${u.id}`));
      const previousValues = new Map(
         selectedSubItems.map((s) => [`${s.parentId}:${s.id}`, s.locked])
      );

      useTableDataState.setState((state) => ({
         data: state.data.map((item) => ({
            ...item,
            subItems: item.subItems?.map((s) =>
               updatedIds.has(`${s.parentId}:${s.id}`) ? { ...s, locked: false } : s
            ),
         })),
      }));

      mutate(updated, {
         onError: () => {
            useTableDataState.setState((state) => ({
               data: state.data.map((item) => ({
                  ...item,
                  subItems: item.subItems?.map((s) =>
                     previousValues.has(`${s.parentId}:${s.id}`)
                        ? { ...s, locked: previousValues.get(`${s.parentId}:${s.id}`)! }
                        : s
                  ),
               })),
            }));
         },
      });
   };

   const areAnyLocked = useCallback(() => {
      let found = false;
      selectedSubItems.forEach((subItem) => {
         if (subItem.locked) found = true;
      });
      return found;
   }, [selectedSubItems]);

   const buttonTooltip = () => {
      if (!areAnyLocked()) return 'You need to select locked row(s) to unlock';
      else return 'Unlock row';
   };

   return (
      <StyledTooltip title={buttonTooltip()}>
         <span>
            <StyledToolbarButton
               ssrIcon={unlockIcon}
               text="Unlock"
               iconOnly={true}
               small={true}
               onClick={onClick}
               disabled={!areAnyLocked()}
            />
         </span>
      </StyledTooltip>
   );
};